"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewVenice = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var SelectSpace_1 = require("../../inputs/SelectSpace");
var TileType_1 = require("../../TileType");
var CardType_1 = require("./../CardType");
var Tags_1 = require("./../Tags");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var NewVenice = (function (_super) {
    __extends(NewVenice, _super);
    function NewVenice() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.NEW_VENICE,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING, Tags_1.Tags.CITY],
            cost: 21,
            productionBox: Units_1.Units.of({ energy: 1, megacredits: 2 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oceans(3); }),
            metadata: {
                cardNumber: 'Pf3',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().plants(2).br;
                    b.production(function (pb) {
                        pb.energy(1).megacredits(2);
                    }).nbsp.tile(TileType_1.TileType.OCEAN_CITY, false, true);
                }),
                description: 'Requires 3 ocean tiles. Lose 2 plants. Increase your energy production 1 step and your M€ production 2 steps. ' +
                    'Place this tile on top of an existing ocean tile, IGNORING NORMAL PLACEMENT RESTRICTIONS FOR CITIES. The tile counts as a city as well as an ocean.',
            },
        }) || this;
    }
    NewVenice.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) && (player.plants >= 2);
    };
    NewVenice.prototype.play = function (player) {
        var _this = this;
        player.adjustProduction(this.productionBox);
        player.plants -= 2;
        return new SelectSpace_1.SelectSpace('Select space for New Venice', player.game.board.getOceansTiles(false), function (space) {
            var tile = {
                tileType: TileType_1.TileType.OCEAN_CITY,
                card: _this.name,
                covers: space.tile,
            };
            player.game.addTile(player, space.spaceType, space, tile);
            return undefined;
        });
    };
    return NewVenice;
}(Card_1.Card));
exports.NewVenice = NewVenice;
